window.settings = {
  env: 'production',
  appInstance: process.env.APP_INSTANCE,
  rollbarClientAccessToken: 'd2d25d4af21142728fe4fa5342009ec6',
  sha: process.env.SHA,
};
